import axios from '../../../helpers/custom-axios';
import { notify } from '../../../helpers/notifications';

export const destroySubmission = async (subId, reduce = null) => {
  let config = reduce ? { reduce: true } : {};
  return axios
    .delete(`/manage/submissions/${subId}`, { params: config })
    .then((res) => {
      notify.success();
      return res;
    })
    .catch((error) => {
      notify.failure();
      return error;
    });
};

export const verifyQuotaStatus = async (subId) => {
  let verifyQuotaStatusPath = `/manage/submissions/${subId}/quota_status`;

  return axios
    .get(verifyQuotaStatusPath)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      return error;
    });
};

export const beginExport = (params) => {
  let element = document.createElement('a');
  element.target = '_blank';
  element.href = `/manage/submissions/export?${params}`;
  element.click();
};

export const queryFormForSub = async (formId, param) => {
  return axios
    .get(`/manage/forms/${formId}/form_has_sub`, {
      params: param,
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const getSubmissionJSON = async (id) => {
  return axios
    .get(`/manage/submissions/${id}.json`)
    .then((res) => res)
    .catch((err) => err);
};
